import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View } from "@common/types/views/views";
import {
    McpCliTokenColumn,
    McpCliTokenRow,
    mcpCliTokensViewConfig,
} from "./mcpCliTokensViewConfig";

const defaultView: View = {
    columns: [
        { id: McpCliTokenColumn.NAME },
        { id: McpCliTokenColumn.PREFIX },
        { id: McpCliTokenColumn.PERMISSIONS },
        { id: McpCliTokenColumn.STATUS },
        { id: McpCliTokenColumn.CREATED },
        { id: McpCliTokenColumn.LAST_USED },
        { id: McpCliTokenColumn.EXPIRES },
        { id: McpCliTokenColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface McpCliTokensViewProps {
    data: McpCliTokenRow[] | null;
}

export const McpCliTokensView: React.FC<McpCliTokensViewProps> = ({ data }) => (
    <ViewTable
        data={data}
        view={defaultView}
        config={mcpCliTokensViewConfig}
        emptyView={() => <EmptyState header="No personal access tokens yet" />}
        enableColumnResizing={false}
        outerBorder
    />
);
